// ShortsDetailJsonLd.js
import { connect } from 'react-redux';

import ShortsDetailJsonLd from '../component/ShortsDetailJsonLd.jsx';

import getMeData from '../selector/getMeData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getUserData from '../selector/getUserData.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getAssetData from '../selector/getAssetData.js';
import getMessageHashtagContentList from '../selector/getMessageHashtagContentList.js';

const mapStateToProps = (state, { messageId }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const unlockPrice = getMessageData(state, messageId, 'unlockPrice');
  const assetIds = getMessageData(state, messageId, 'assetIds');
  const firstAssetId = assetIds?.[0];
  const meUsername = getMeData(state, 'username');
  return {
    messageId,
    ogMessageThumbnail: getMessageThumbnail(
      state,
      messageId,
      '',
      '512x512',
      'jpg',
      unlockPrice ? 'preview' : 'clear'
    ),
    title: getMessageDataWithVariable(
      state,
      messageId,
      'title',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    captionText: getMessageDataWithVariable(
      state,
      messageId,
      'captionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    senderId,
    senderUsername: getUserData(state, senderId, 'username'),
    firstAssetId,
    sourceId: getMessageData(state, messageId, 'sourceId'),
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    unlockPrice,
    viewCount: getMessageData(state, messageId, 'views'),
    likeCount: getMessageData(state, messageId, 'likes'),
    firstAssetDuration: getAssetData(state, [firstAssetId], 'duration'),
    hashtagContentList: getMessageHashtagContentList(state, messageId),
  };
};

export default connect(mapStateToProps)(ShortsDetailJsonLd);
